export const GET_ADMIN_USER_NOTIFICATIONS = "GET_ADMIN_USER_NOTIFICATIONS"
export const GET_ADMIN_USER_NOTIFICATIONS_SUCCESS = "GET_ADMIN_USER_NOTIFICATIONS_SUCCESS"
export const GET_ADMIN_USER_NOTIFICATIONS_ERROR = "GET_ADMIN_USER_NOTIFICATIONS_ERROR"

export const CREATE_USER_NOTIFICATIONS = "CREATE_USER_NOTIFICATIONS"
export const CREATE_USER_NOTIFICATIONS_SUCCESS = "CREATE_USER_NOTIFICATIONS_SUCCESS"
export const CREATE_USER_NOTIFICATIONS_ERROR = "CREATE_USER_NOTIFICATIONS_ERROR"

export const UPDATE_USER_NOTIFICATIONS = "UPDATE_USER_NOTIFICATIONS"
export const UPDATE_USER_NOTIFICATIONS_SUCCESS = "UPDATE_USER_NOTIFICATIONS_SUCCESS"
export const UPDATE_USER_NOTIFICATIONS_ERROR = "UPDATE_USER_NOTIFICATIONS_ERROR"

export const DELETE_USER_NOTIFICATIONS = "DELETE_USER_NOTIFICATIONS"
export const DELETE_USER_NOTIFICATIONS_SUCCESS = "DELETE_USER_NOTIFICATIONS_SUCCESS"
export const DELETE_USER_NOTIFICATIONS_ERROR = "DELETE_USER_NOTIFICATIONS_ERROR"

export const EXPORT_ADMIN_USER_NOTIFICATIONS = "EXPORT_ADMIN_USER_NOTIFICATIONS"
export const EXPORT_ADMIN_USER_NOTIFICATIONS_SUCCESS = "EXPORT_ADMIN_USER_NOTIFICATIONS_SUCCESS"
export const EXPORT_ADMIN_USER_NOTIFICATIONS_ERROR = "EXPORT_ADMIN_USER_NOTIFICATIONS_ERROR"